module.exports = __webpack_public_path__ + "media/images/application/favicon/safari-pinned-tab-476d12dc5b6eed7578468e32d02a5362.svg";